/**
 * «Вакансія» чи «Замовлення» (owner 2026-09-20).
 *
 * Власник: вакансія — коли шукає компанія або команда; замовлення — коли
 * конкретна людина шукає виконавця під конкретну задачу. Чого AI не змогла
 * визначити — не підписуємо взагалі: мітка стоїть у спільному ряду з форматом
 * і категорією, а не окремим блоком, тому «не визначено» там було б шумом.
 */
const KIND: Record<string, { label: string; cls: string }> = {
  job: { label: "Вакансія", cls: "text-amber-700 bg-amber-100" },
  order: { label: "Замовлення", cls: "text-teal-700 bg-teal-100" },
};

export function WorkKindBadge({ kind }: { kind?: string | null }) {
  const b = kind ? KIND[kind] : undefined;
  if (!b) return null;
  return (
    <span
      className={
        "inline-block font-mono text-[0.625rem] tracking-[0.04em] px-2 py-0.5 rounded-full shrink-0 " +
        b.cls
      }
    >
      {b.label}
    </span>
  );
}
